module.exports = __webpack_public_path__ + "static/media/dhi_gras_logo_transparent.64fe5297.png";